import authorImage from "assets/img/blog/265290455a2f322a45450b1c36b25da0.jpg";
import img01 from "assets/img/blog/martin-hoffmann-9LkmOjkVEgM-unsplash.jpg";
import img02 from "assets/img/blog/scott-webb-87890-unsplash.jpg";
import img03 from "assets/img/blog/02-s03-0240.jpg";
import img04 from "assets/img/blog/beasty-0BcxmQx9xas-unsplash.jpg";
import img05 from "assets/img/blog/brooke-cagle-uAfjZu--U2g-unsplash.jpg";
import img06 from "assets/img/blog/alex-rodriguez-santibanez-TS6Ml8mSXQU-unsplash.jpg";
import img07 from "assets/img/blog/amy-shamblen-746542-unsplash.jpg";
import img08 from "assets/img/blog/sagar-rana-bFDdb5Yl_-w-unsplash.jpg";

const author = {
  firstname: "Vennear",
  lastname: "Galecki",
  email: "hello@sugarpep.com",
  image: authorImage,
};

const summary =
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt…\n\nSed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?";

const content =
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt…\n\nSed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?\n\n![enter image description here](https://images.unsplash.com/photo-1481349518771-20055b2a7b24?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1000&q=80)\n\nLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptat.";

const entries = [
  {
    title: "Balancing Love, Life, and Work for Leo",
    date: "July 21, 2019",
    summary,
    content,
    category: "Tips",
    thumbnail: img01,
    slug: "balancing-love-life-and-work-for-leo",
    author,
  },
  {
    title: "10 Ways to Improve Your Taste",
    date: "May 20, 2019",
    summary,
    content,
    category: "Tips",
    thumbnail: img02,
    slug: "10-ways-to-improve-your-taste",
    author,
  },
  {
    title: "Why is Oil Perfume Better?",
    date: "May 8, 2019",
    summary,
    content,
    category: "Facts",
    thumbnail: img03,
    slug: "why-is-oil-perfume-better",
    author,
  },
  {
    title: "How Do We Pack Magic In Every Bottle?",
    date: "April 5, 2019",
    summary,
    content,
    category: "Facts",
    featured: true,
    thumbnail: img04,
    slug: "how-do-we-pack-magic-in-every-bottle",
    author,
  },
  {
    title: "Nurturing Leo’s Nature",
    date: "March 29, 2019",
    summary,
    content,
    category: "Tips",
    thumbnail: img05,
    slug: "nurturing-leos-nature",
    author,
  },
  {
    title: "Bring Your Career Forward — Leo Style",
    date: "February 22, 2019",
    summary,
    content,
    category: "Tips",
    thumbnail: img06,
    slug: "bring-your-career-forward-leo-style",
    author,
  },
  {
    title: "How Accurate is the Horoscope System?",
    date: "February 4, 2019",
    summary,
    content,
    category: "Facts",
    thumbnail: img07,
    slug: "how-accurate-is-the-horoscope-system",
    author,
  },
  {
    title: "Are You Making These Perfume Mistakes?",
    date: "January 18, 2019",
    summary,
    content,
    category: "Tips",
    thumbnail: img08,
    slug: "are-you-making-these-perfume-mistake",
    author,
  },
];

export default entries;
